module.exports = __webpack_public_path__ + "0e787ef5ffc6f5c282b392f0270b1244.svg";